module.exports = __webpack_public_path__ + "img/center.e98ef931.svg";